import React from "react";
import { useSelector } from "react-redux";
import { useGetUserPointBasedBadgesQuery } from "../../../redux-toolkit/features/my-activity/myActivityApiSlice";
import BaseJourney from "./BaseJourney";

const PointsJourney = ({ currentProgress }) => {
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;

  const {
    data: pointBadgesData,
    isLoading,
  } = useGetUserPointBasedBadgesQuery(userId);

  // Get badges from API data
  const earnedBadges = pointBadgesData?.data?.earnedBadges || [];

  // Sort badges by valueThreshold to ensure correct order
  const sortedBadges = [...earnedBadges].sort(
    (a, b) => a.valueThreshold - b.valueThreshold
  );

  // Calculate progress based on earned badges
  const earnedBadgesCount = sortedBadges.filter(
    (badge) => badge.isEarned
  ).length;
  const totalBadges = sortedBadges.length;
  const maxProgress = totalBadges || 5; // Use total badges as max progress
  const calculatedProgress = totalBadges > 0 ? earnedBadgesCount : 0;


  // Create timeline markers from badge thresholds
  const timelineMarkers =
    sortedBadges.length > 0
      ? sortedBadges.map((badge) => badge.valueThreshold.toString())
      : ["100", "500", "1000", "1500", "2000"]; // Fallback markers

  // Transform API data to match our badge structure
  const badgeData =
    sortedBadges.length > 0
      ? sortedBadges.map((badge) => ({
          id: badge._id || badge.valueThreshold,
          image: badge.badgeImage || "",
          title: (
            badge.badgeName || `${badge.valueThreshold} Points`
          ).toUpperCase(),
          description: getBadgeDescription(badge.valueThreshold),
          isAchieved: Boolean(badge.isEarned),
        }))
      : []; // Empty array if no API data

  // Helper function to generate badge descriptions
  function getBadgeDescription(threshold) {
    switch (threshold) {
      case 100:
        return "First milestone in your point collection";
      case 500:
        return "Building your point empire";
      case 1000:
        return "Point collector extraordinaire";
      case 1500:
        return "Almost at the pinnacle";
      case 2000:
        return "Point master of the realm";
      case 2500:
        return "Ultimate point collector";
      default:
        return `Earn ${threshold} points to unlock this badge`;
    }
  }

  // Show loading state if badges are still loading
  if (isLoading) {
    return (
      <div className="journey-container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            color: "#fff",
            fontSize: "1rem",
          }}
        >
          Loading point badges...
        </div>
      </div>
    );
  }

  return (
    <BaseJourney
      currentProgress={calculatedProgress}
      maxProgress={maxProgress}
      badgeData={badgeData}
      timelineMarkers={timelineMarkers}
      progressColor="#4CAF50"
      actualScore={currentProgress} // Pass the actual points count for comparison with valueThreshold
    />
  );
};

export default PointsJourney;
